import React from 'react';
import request from 'superagent';
import { Link } from 'react-router';

import '../components/Forum/ForumBanner.scss';

import siteBanner_img from '../assets/img/llc/sectionTopBanner.jpg';
import { ForumMenu, ForumItem } from "../components";

import config from '../constants/config';

const threadsOnPage = 8;

class ForumContainer extends React.Component {
  constructor() {
    super();

    this.state = {
      surgeryActive: 0,
      procedureActive: 0,
      displayed: 0,
      threads: [],
      loading: false
    }
  }

  updateThreads = () => {
    this.setState({loading: true});
    request.get(config.apiUrl + 'getThreads')
      .query({
        count: this.state.displayed + threadsOnPage,
        surgery: this.state.surgeryActive,
        procedure: this.state.procedureActive
      })
      .then((res) => {
        this.setState({
          threads: res.body,
          loading: false,
          showButton: (this.state.displayed + threadsOnPage) <= res.body.length
        })
      })
  };

  componentDidMount = () => {
    this.updateThreads();
  };

  componentDidUpdate = (newProps, newState) => {
    if (
      newState.surgeryActive !== this.state.surgeryActive ||
      newState.procedureActive !== this.state.procedureActive ||
      newState.displayed !== this.state.displayed
    ) {
      this.updateThreads();
    }
  };

  loadMore = () => {
    this.setState({
      displayed: this.state.displayed + threadsOnPage
    })
  };

  changeActiveTab = (e) => {
    this.setState({
      surgeryActive: parseInt(e.currentTarget.id),
      procedureActive: 0,
      displayed: 0
    })
  };

  changeActiveProcedure = (e) => {
    this.setState({
      procedureActive: parseInt(e.currentTarget.id),
      displayed: 0
    })
  };

  render() {
    const langs = this.props.texts.langs;

    return (
      <div className="bc-beige2 p-b-50">
        <div className="siteBanner forumBanner newBg">
          <img src={siteBanner_img} className="siteBanner_bg"/>
          <div className="forumBanner_inner">
            <h2 className="line">Poradna</h2>
            <div className="forumBanner_form">
              {/*
              <div className="forumBanner_form_search">
                <input type="text" placeholder="Hledejte..."/>
                <div className="forumBanner_form_search_btn"><i className="llc-find"/></div>
              </div>
              */}
              <Link to="/poradna/dotaz" className="btn">PŘIDAT DOTAZ</Link>
            </div>
          </div>
        </div>
        <ForumMenu
          langs={{
            surgery: langs.surgery
          }}
          surgeryActive={this.state.surgeryActive}
          procedureActive={this.state.procedureActive}
          handleSurgeryClick={this.changeActiveTab}
          handleProcedureClick={this.changeActiveProcedure}
        />
        <ForumItem
          loading={this.state.loading}
          langs={{
            doctors: langs.doctors
          }}
          threads={this.state.threads}
        />
        <div className="text-center">
          {this.state.showButton &&
          <div onClick={this.loadMore} className="btn">Zobrazit více vláken</div>
          }
          {this.state.threads.length === 0 &&
          <h2>Pro tuto kategorii nejsou žádné dotazy</h2>
          }
        </div>
      </div>
    );
  }
}

export default ForumContainer;



// WEBPACK FOOTER //
// ./src/containers/Forum.js